import { Component, OnInit, Inject, Input, ElementRef, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { ShopSettingsService } from '../../services/shop-settings.service';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {

  message: string;

  faExclamationTriangle = faExclamationTriangle;

  @Input()
  title = 'Achtung!';

  @Input()
  noCaption = 'Cancel';

  @Input()
  yesCaption = 'Accept';

  @Input()
  hideNoButton = false;

  @Input()
  hideYesButton = false;

  @Input()
  hideIcon = false;

  constructor(
    public dialogRef: MatDialogRef<MessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private ref: ElementRef,
    public shopSettingsService: ShopSettingsService,
    private renderer: Renderer2,
  ) {
    if (data.title) {
      this.title = data.title;
    }
    this.message = data.message;
    if (data.title) {
      this.title = data.title;
    }
    if (data.noCaption) {
      this.noCaption = data.noCaption;
    }
    if (data.yesCaption) {
      this.yesCaption = data.yesCaption;
    }
    if (data.hideNoButton) {
      this.hideNoButton = data.hideNoButton;
    }
    if (data.hideYesButton) {
      this.hideYesButton = data.hideYesButton;
    }
    if (data.hideIcon) {
      this.hideIcon = data.hideIcon;
    }
  }

  ngOnInit(): void {
    if (this.shopSettingsService.isVUMode) {
      this.renderer.addClass(this.ref.nativeElement, 'vu-mode');
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close();
  }

}
